import React, { useState } from 'react';
import { isSafari } from 'react-device-detect';
import {
  AiFillExclamationCircle,
  AiOutlineMinus,
  AiOutlinePlus,
} from 'react-icons/ai';
import { InputNoForm } from '~/components/Forms';
import { RadioNoForm } from '~/components/Forms/RadioNoForm';
import Load from '~/components/Load';
import WhiteBox from '~/components/WhiteBox';
import { BoxHeader } from '~/pages/Usuario/styles';
import { showModalMessage } from '~/services/notification';
import {
  ActionInputMulti,
  ContainerMultiInputActions,
  GridContainer,
  Wrap,
} from '~/styles/components';
import ApiClient from '~/utils/ApiClient';

export const ContatoResponsavel = ({
  boxTitle,
  boxInfo,
  responsaveis,
  setResponsaveis,
  viewMode,
  editMode,
  bottomSize,
}) => {
  const [loading, setLoading] = useState(false);

  const handleEmailExists = async (event, index) => {
    const { value } = event.target;

    if (!value) return;

    setLoading(true);

    try {
      await ApiClient.doRequest({
        uri: `user/exist-by-email/${value}`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      setLoading(false);

      await showModalMessage({
        type: 'error',
        text: `Email '${value}' já cadastrado. Por favor, informe outro.`,
      });

      const values = [...responsaveis];
      values[index][event.target.name] = '';
      setResponsaveis(values);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleSearchPhysicalPerson = async (event, index) => {
    const { value } = event.target;
    const searchValue = value?.replace(/[^0-9]/g, '');

    try {
      if (!searchValue || searchValue.length !== 11) throw new Error();

      setLoading(true);

      const response = await ApiClient.doRequest({
        uri: `/user/find/${searchValue}`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      setLoading(false);

      const data = response?.data?.data;
      const values = [...responsaveis];

      values[index] = {
        ...values[index],
        uuid: data?.uuid,
        name: data?.user_personal_data?.name,
        email: data?.email,
        phone_mobile: data?.user_personal_data?.phone_mobile,
        rg: data?.user_personal_data?.rg,
        birth_date: data?.user_birth_address?.birth_date,
        send_email: null,
      };

      setResponsaveis(values);
    } catch (err) {
      setLoading(false);

      const values = [...responsaveis];
      values[index] = {
        ...values[index],
        uuid: '',
        name: '',
        email: '',
        phone_mobile: '',
        rg: '',
        birth_date: '',
        send_email: null,
      };
      setResponsaveis(values);

      if (editMode) {
        await showModalMessage({
          type: 'error',
          text: `Informe o CPF de um usuário já cadastrado no sistema.`,
        });
      }
    }
  };

  const handleRemoveBox = ({ index }) => {
    setResponsaveis(responsaveis?.filter((_, idx) => idx !== index));
  };

  const handleAddBox = () => {
    setResponsaveis(prevState => [...prevState, { uuid: '' }]);
  };

  const handleChange = ({ index, event }) => {
    const values = [...responsaveis];
    values[index][event.target.name] = event.target.value;
    setResponsaveis(values);
  };

  return (
    <>
      <Load inLoad={loading} />

      <WhiteBox column marginBottom="30px" bottom={bottomSize}>
        <BoxHeader style={{ justifyContent: 'space-between' }}>
          <span className="boxText">{boxTitle}</span>
          <div style={{ display: 'flex' }}>
            {boxInfo && (
              <span tooltip={boxInfo} style={{ marginRight: 5 }}>
                <AiFillExclamationCircle />
              </span>
            )}
          </div>
        </BoxHeader>

        {responsaveis?.map((inputField, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Wrap key={`${inputField}~${index}`}>
            <WhiteBox column style={{ bottom: '0' }}>
              <BoxHeader style={{ justifyContent: 'flex-end' }}>
                {!viewMode && (
                  <ContainerMultiInputActions>
                    {responsaveis.length !== 1 && (
                      <ActionInputMulti
                        type="button"
                        onClick={() =>
                          handleRemoveBox({
                            index,
                          })
                        }
                      >
                        <AiOutlineMinus color="#AAA" size={24} />
                      </ActionInputMulti>
                    )}

                    {responsaveis.length - 1 === index && (
                      <ActionInputMulti type="button" onClick={handleAddBox}>
                        <AiOutlinePlus color="#AAA" size={24} />
                      </ActionInputMulti>
                    )}
                  </ContainerMultiInputActions>
                )}
              </BoxHeader>

              <Wrap>
                <GridContainer cols={3}>
                  <InputNoForm
                    type="text"
                    name="cpf"
                    mask="999.999.999-99"
                    maskChar=""
                    label="CPF"
                    disabled={viewMode}
                    value={inputField.cpf}
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                    onBlur={event => handleSearchPhysicalPerson(event, index)}
                    required
                  />
                  <InputNoForm
                    type="text"
                    name="name"
                    label="Nome Civil/Nome Social"
                    required
                    value={inputField.name}
                    disabled={inputField.uuid || editMode}
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                  />
                  <InputNoForm
                    type="text"
                    name="email"
                    label="E-mail"
                    disabled={inputField.uuid || editMode}
                    value={inputField.email}
                    onBlur={e => handleEmailExists(e, index)}
                    required
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                  />
                  <InputNoForm
                    type="text"
                    name="phone_mobile"
                    mask="(99) 99999-9999"
                    maskChar=""
                    label="Celular"
                    value={inputField.phone_mobile}
                    disabled={inputField.uuid || editMode}
                    required
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                  />
                  <InputNoForm
                    type="text"
                    name="rg"
                    label="RG/RNE"
                    value={inputField.rg}
                    disabled={inputField.uuid || editMode}
                    required
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                  />
                  <InputNoForm
                    type="date"
                    name="birth_date"
                    label="Data de nascimento"
                    value={inputField.birth_date}
                    disabled={inputField.uuid || editMode}
                    acceptPast
                    placeholder={isSafari && 'aaaa-mm-dd'}
                    required
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                  />
                </GridContainer>
              </Wrap>
              {!viewMode && !loading && (
                <Wrap>
                  <RadioNoForm
                    name="send_email"
                    label="Deseja que esse usuário receba notificações automáticas enviadas pelo sistema?"
                    required
                    value={inputField.send_email}
                    onChange={event =>
                      handleChange({
                        index,
                        event,
                      })
                    }
                  />
                </Wrap>
              )}
            </WhiteBox>
          </Wrap>
        ))}
      </WhiteBox>
    </>
  );
};
